<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('measure', 1) })"
    :value="value"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <v-row class="my-0">
      <v-col cols="12" md="6">
        <ValidationProvider
          vid="name"
          :name="$tc('name', 1)"
          rules="required"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            name="name"
            outlined
            :error-messages="errors[0]"
            :label="$tc('name', 1)"
            v-model="sold.name"
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" md="6">
        <ValidationProvider
          vid="abbr"
          :name="$tc('abbr', 1)"
          rules="required"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            name="abbr"
            outlined
            :disabled="sold.static"
            :error-messages="errors[0]"
            :label="$tc('abbr', 1)"
            v-model="sold.abbr"
          />
        </ValidationProvider>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      sold: {
        name: '',
        abbr: ''
      },
      edit: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.sold =
            this.toEdit !== null ? { ...this.toEdit } : { name: '', abbr: '' }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          const sold = !this.edit
            ? await this.$api.sold.create({ form: this.sold })
            : await this.$api.sold.edit({
                pk: this.sold.pk,
                form: this.sold
              })
          this.$emit('done', sold.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('measure', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
